import { PRESCRIPTION_BUILDER_VIEW_TYPES } from 'src/consumer/constants'

export const DEFAULT_PRESCRIPTION_PRINT_SETTINGS = {
  prescriptionMaxPages: 100,
  marginTop: 0,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  useNewPrintMethod: true,
  headerSettings: {
    headerStyle: 'onAllPages',
    headerHeight: 2,
    showBlankHeader: false,
  },
  footerSettings: {
    footerStyle: 'onAllPages',
    footerHeight: 1.75,
    showBlankFooter: false,
  },
  leftSidebarSettings: {
    width: 0,
  },
  rightSidebarSettings: {
    width: 0,
  },
}

export const DEFAULT_PRESCRIPTION_VIEW_SETTINGS = {
  prescriptionBuilderViewType: PRESCRIPTION_BUILDER_VIEW_TYPES.minimal,
  drugAdviceTablePrintType: 'default',
  preferredPrescriptionLanguages: ['en'],
  showPdfDownloadRelatedButtons: false,
  showPrescriptionQR: false,
  paperPrintSettings: DEFAULT_PRESCRIPTION_PRINT_SETTINGS,
  pdfPrintSettings: DEFAULT_PRESCRIPTION_PRINT_SETTINGS,
}

function mergePrintSettings(printSettings) {
  return {
    ...DEFAULT_PRESCRIPTION_PRINT_SETTINGS,
    ...(printSettings || {}),
    useNewPrintMethod: printSettings?.useNewPrintMethod ?? true,
    headerSettings: {
      ...DEFAULT_PRESCRIPTION_PRINT_SETTINGS.headerSettings,
      ...(printSettings?.headerSettings || {}),
    },
    footerSettings: {
      ...DEFAULT_PRESCRIPTION_PRINT_SETTINGS.footerSettings,
      ...(printSettings?.footerSettings || {}),
    },
    leftSidebarSettings: {
      ...DEFAULT_PRESCRIPTION_PRINT_SETTINGS.leftSidebarSettings,
      ...(printSettings?.leftSidebarSettings || {}),
    },
    rightSidebarSettings: {
      ...DEFAULT_PRESCRIPTION_PRINT_SETTINGS.rightSidebarSettings,
      ...(printSettings?.rightSidebarSettings || {}),
    },
  }
}

export function normalizePrescriptionViewSettings(settings) {
  return {
    ...DEFAULT_PRESCRIPTION_VIEW_SETTINGS,
    ...(settings || {}),
    preferredPrescriptionLanguages:
      settings?.preferredPrescriptionLanguages || DEFAULT_PRESCRIPTION_VIEW_SETTINGS.preferredPrescriptionLanguages,
    drugAdviceTablePrintType:
      settings?.drugAdviceTablePrintType || DEFAULT_PRESCRIPTION_VIEW_SETTINGS.drugAdviceTablePrintType,
    paperPrintSettings: mergePrintSettings(settings?.paperPrintSettings),
    pdfPrintSettings: mergePrintSettings(settings?.pdfPrintSettings),
  }
}
